const React = require('react');
const isNode = (typeof process !== 'undefined');
const {Collapse} = isNode ? require('react-collapse') : () => null;
const presets = isNode ? require('react-motion') : () => {};
const _ = require('../../../../lib/underscore');
const axios = isNode && require('axios');

const MODE_BROWSE = 'browse';
const MODE_SEARCH_RESULTS = 'search-results';

class Handbook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchResults: [],
            searchQuery: null,
            selectedCategory: null,
            selectedArticle: null,
            mode: MODE_BROWSE
        };
        this.search = this.search.bind(this);
    }

    componentDidMount() {
        this.searchDebounce = _.debounce(this.search, 200);
    }


    search() {
        const {searchQuery} = this.state;
        if (searchQuery.length >= 3) {
            const {searchUrl, contentPath} = this.props;
            this.setState({
                selectedCategory: null,
                selectedArticle: null
            });

            axios({
                url: `${searchUrl}?contentPath=${contentPath}&query=${searchQuery}`,
                method: 'get',
            }).then(res => {
                this.setState({
                    searchResults: res.data.hits,
                    mode: MODE_SEARCH_RESULTS
                })
            });
        } else {
            this.setState({ mode: MODE_BROWSE, selectedArticle: null })
        }
    }

    renderArticle(article) {
        const {selectedArticle} = this.state;
        const isOpen = article._id === selectedArticle;

        const articleContent = (
            <article className="handbook__articleContent">
                <div dangerouslySetInnerHTML={{__html: article.data.excerpt}}/>
                <div className="handbook__sections">
                    {article.data.bodySections.map(section => {
                        return(
                            <div>
                                <h3>{section.title}</h3>
                                <div dangerouslySetInnerHTML={{__html: section.body}}/>
                            </div>
                        )
                    })}
                    <p>
                        <a className="handbook__permalink" href={article.link}>
                            <svg x="0" y="0" viewBox="0 0 48 48">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="v-1.3" transform="translate(-288.000000, -2784.000000)" fill="#4D4D4D">
                                        <g id="UI" transform="translate(96.000000, 2496.000000)">
                                            <g id="Attachment" transform="translate(192.000000, 288.000000)">
                                                <path d="M28.2842712,24.755893 L21.2109682,31.829196 C20.4333125,32.6068517 19.164678,32.6068624 18.3847763,31.8269608 C17.605313,31.0474974 17.6043194,29.7789905 18.3825411,29.0007689 L28.2842712,19.0990387 C29.0653198,18.3179901 29.0653198,17.0516602 28.2842712,16.2706116 C27.5032227,15.489563 26.2368927,15.489563 25.4558441,16.2706116 L15.5541139,26.1723418 C13.2128024,28.5136533 13.2157797,32.3148184 15.5563492,34.6553879 C17.8983587,36.9973974 21.6996532,36.9973652 24.0393953,34.6576231 L31.1126984,27.5843201 L40.3038668,18.3931516 C43.8175067,14.8795118 43.8159962,9.17491954 40.3050865,5.66400986 C36.790594,2.14951731 31.0905532,2.15062113 27.5759447,5.66522959 L18.3847763,14.856398 L8.48527375,24.7559006 C3.79871609,29.4424582 3.79840156,37.0395759 8.48528137,41.7264557 C13.172029,46.4132033 20.7685539,46.413746 25.4558365,41.7264633 L38.1837662,28.9985336 C38.9648148,28.2174851 38.9648148,26.9511551 38.1837662,26.1701065 C37.4027176,25.3890579 36.1363876,25.3890579 35.3553391,26.1701065 L22.6274094,38.8980362 C19.5023144,42.0231312 14.4384494,42.0227695 11.3137085,38.8980286 C8.18897828,35.7732984 8.18918796,30.7088406 11.3137009,27.5843277 L21.2132034,17.6848251 L30.4043719,8.49365671 C32.3571283,6.54090025 35.5245093,6.54028688 37.4766594,8.49243698 C39.4258071,10.4415847 39.426647,13.6135172 37.4754397,15.5647245 L28.2842712,24.755893 L28.2842712,24.755893 Z" id="Combined-Shape"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            Lenke
                        </a>
                    </p>
                </div>
            </article>
        );

        return (
        <div className="handbook__article">
            <h3 className="handbook__articleTitle" onClick={() => this.setState({ selectedArticle: isOpen ? null : article._id })}>
                {article.displayName}
                <svg className={'handbook__arrow' + (isOpen ? ' handbook__arrow--open' : '')} x="0px" y="0px" viewBox="0 0 960 560">
                    <g>
                        <path d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937
                                        c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937
                                        c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"/>
                    </g>
                </svg>
            </h3>
            {isNode ? (
            <Collapse isOpened={isOpen} springConfig={presets.stiff}>
                {articleContent}
            </Collapse>
            ) : (
             <div className="handbook__articleContent">
                 {articleContent}
             </div>
             )}
        </div>
        )
    }

    render() {
        const {title, intro, categories} = this.props;
        const {searchResults, searchQuery, selectedCategory, selectedArticle, mode} = this.state;

        const category = categories.filter(category => {
            return category._id === selectedCategory
        }).shift();
        const articles = (category && category.articles && category.articles.length) ? category.articles : [];

        return (
        <section className="handbook">
            <div className="handbook__container">

                <div className="handbook__top">
                    <h2 className="handbook__title">{title}</h2>
                    <p className="handbook__intro">{intro}</p>
                </div>

                <div className="handbook__content">
                    <div className="handbook__left">
                        <ul className="handbook__categories">
                            {categories.map((category) => {
                                return (
                                <li className="handbook__categoryItem">
                                    <h3 className={'handbook__categoryTitle' + (selectedCategory === category._id ? ' handbook__categoryTitle--selected' : '')} onClick={() => this.setState({ searchQuery: null, selectedCategory: category._id, selectedArticle: null, mode: MODE_BROWSE })}>{category.displayName}</h3>
                                </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="handbook__right">
                        <div className="handbook__search">
                            <svg  x="0px" y="0px" viewBox="0 0 45 45">
                                <g>
                                    <path fill="#535868" d="M41.1,39.7L30.2,28.9c1.9-2.5,3.1-5.7,3.1-9.1c0-8.3-6.7-15-15-15c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15
            c3.4,0,6.6-1.1,9.1-3.1l10.9,10.9c0.8,0.8,2,0.8,2.8,0C41.9,41.8,41.9,40.5,41.1,39.7z M18.3,30.8c-6.1,0-11-4.9-11-11
            s4.9-11,11-11s11,4.9,11,11S24.4,30.8,18.3,30.8z"/>
                                </g>
                            </svg>
                            <form action="#">
                                <input type="text" placeholder="Søk..." onChange={ev => { this.setState({searchQuery: ev.target.value}); this.searchDebounce();}} value={this.state.searchQuery} />
                            </form>
                        </div>


                        <div className="handbook__articles">
                            {mode === MODE_BROWSE && (
                            <div>
                                {!category && (
                                <div className="handbook__notice">
                                    <h2>Ingen kategori er valgt&hellip;</h2>
                                    <p>Velg en kategori ved å trykke på lenkene til venstre</p>
                                </div>
                                )}
                                {articles.map(article => this.renderArticle(article))}
                            </div>
                            )}

                            {mode === MODE_SEARCH_RESULTS && (
                                searchResults.length === 0 ? (
                                    <div className="handbook__notice">
                                        <h2>Beklager&hellip;</h2>
                                        <p>Vi fant ingen treff på søkeordet &laquo;{searchQuery}&raquo;</p>
                                    </div>
                                ) : (
                                    searchResults.map(article => this.renderArticle(article))
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        )
    }
}

module.exports = Handbook;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/handbook/Component/index.jsx